<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  rightData2: {
    type: Array,
    default: () => [],
  },
  rightData2Cur:{
    type: Number,
    default: () => 0,
  }
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.rightData2,props.rightData2Cur);
});


function initChart() {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let data = {
    xAxisData: ["小麦", "玉米", "大豆"],
    seriesData: [
      [200, 85, 134],
      [123, 55, 234],
      [156.34, 98, 145]
    ]
  };
  const option= {
    color: ["#63caff", "#49beff", "#ddc854", "#ddc854"],
    grid: {
      top: '23%',
      left: '3%',
      right: '3%',
      bottom: '5%',
      containLabel: true,
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        console.log(params)
        let str = `${params[0].name}<br>`;
        params.forEach(item => {
          if(item.seriesName=="总量（吨）"){
            str += `<div style="display: flex; "><div style="margin-right: 10px;">${item.marker} ${item.seriesName}  </div>  ${item.value}吨</div>`
          }else{
            str += `<div style="display: flex;"><div style="margin-right: 10px;">${item.marker} ${item.seriesName}  </div>  ${item.value}公斤</div>`
          }

        })
        return str;
      }
    },
    legend: {
      // orient: 'horizontal' ,
      left: 'center',
      top:"5%",
      itemGap:100,
      itemWidth:30,
      itemHeight:20,
      textStyle: {
        color: "#fff",
        fontSize:'30',
        padding:[0,0,0,10]
      }
    },
    xAxis: {
      type: 'category',
      data: data.xAxisData,
      splitLine: {
        show: false,
      },
      axisLabel: {
        color: "#ffffff",
        fontSize: 30,
        interval: 'auto', // x轴间距
        // rotate:40
      },
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(152, 212, 255, .5)',
        }
      },
    },
    yAxis: [{
      type: 'value',
      name: "公斤/吨",
      nameGap: '30',
      min: 0,
      axisTick: {
        show: false
      },
      axisLabel: {
        show: true,
        fontSize: 30,
        color: "#fff",
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: 'rgba(152, 212, 255, .5)',
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(152, 212, 255, .1)',
        }
      },
      nameTextStyle: {
        color: "#fff    ",
        fontWeight: 400,
        fontSize: 30,
      },
    }],
    series: [{
      data: data.seriesData[0],
      type: "bar", // 柱图
      barMaxWidth: "auto",
      barWidth: 50,

      name: "亩产量（公斤）",
      itemStyle: {
        color: {
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
          colorStops: [{
            offset: 0,
            color: "#37FAC9"
          }, {
            offset: 1,
            color: "#025C40"
          }]
        }
      }
    },
      {
        data: data.seriesData[1],
        type: "bar", // 柱图
        barMaxWidth: "auto",
        barWidth: 50,
        name: "高标亩产量（公斤）",
        itemStyle: {
          color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            type: "linear",
            global: false,
            colorStops: [{
              offset: 0,
              color: "#0CCEFB"
            }, {
              offset: 1,
              color: "#0871E6"
            }]
          }
        }
      },
      {
        data: data.seriesData[2],
        type: "bar", // 柱图
        barMaxWidth: "auto",
        barWidth: 50,
        barGap:"80%",
        name: "总量（吨）",
        itemStyle: {
          color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            type: "linear",
            global: false,
            colorStops: [{
              offset: 0,
              color: "#E5B26B"
            },{
              offset: 1,
              color: "#D68B0A"
            }]
          }
        }
      }
    ]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
